// Structured Data (JSON-LD) for SEO

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Out of Box",
  "description": "Professional company registration services worldwide. Fast, reliable, and expert assistance for your business formation needs.",
  "url": process.env.REACT_APP_SITE_URL || window.location.origin,
  "logo": `${process.env.REACT_APP_SITE_URL || window.location.origin}/logo512.png`,
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "areaServed": "Worldwide",
    "availableLanguage": ["English"]
  },
  "sameAs": [
    // Add your social media URLs here when available
    // "https://www.facebook.com/outofbox",
    // "https://www.linkedin.com/company/outofbox",
    // "https://twitter.com/outofbox"
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "Global",
    "addressLocality": "Worldwide"
  },
  "founder": {
    "@type": "Person",
    "name": "Out of Box Team"
  },
  "foundingDate": "2020",
  "numberOfEmployees": "10-50",
  "serviceArea": {
    "@type": "Place",
    "name": "Worldwide"
  }
});

export const getWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Out of Box",
  "description": "Professional company registration services worldwide",
  "url": process.env.REACT_APP_SITE_URL || window.location.origin,
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": `${process.env.REACT_APP_SITE_URL || window.location.origin}/search?q={search_term_string}`
    },
    "query-input": "required name=search_term_string"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Out of Box"
  }
});

export const getServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Company Registration Services",
  "description": "Professional company registration and business formation services for international businesses",
  "provider": {
    "@type": "Organization",
    "name": "Out of Box"
  },
  "areaServed": "Worldwide",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Business Formation Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Company Formation",
          "description": "Complete company registration and formation services"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Nominee Services",
          "description": "Professional nominee director and shareholder services"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Banking Assistance",
          "description": "Corporate bank account opening assistance"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Compliance Services",
          "description": "Ongoing compliance and regulatory support"
        }
      }
    ]
  },
  "category": "Business Services",
  "serviceType": "Company Registration"
});

export const getBreadcrumbSchema = (breadcrumbList) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbList.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "Out of Box",
  "description": "Professional company registration services worldwide",
  "url": process.env.REACT_APP_SITE_URL || window.location.origin,
  "telephone": "+1-XXX-XXX-XXXX", // Add actual phone number
  "priceRange": "$$",
  "openingHours": "Mo-Fr 09:00-18:00",
  "serviceArea": {
    "@type": "Place",
    "name": "Worldwide"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Business Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "International Company Registration"
        }
      }
    ]
  }
});